import {
  StatusError,
  StatusOK,
  StatusWarning,
} from '@backstage/core-components';

const DAYS = {
  RED_BOUNDARY: 120,
  ORANGE_BOUNDARY: 60,
};

const PIPELINE_COUNT = {
  RED_BOUNDARY: 200,
  ORANGE_BOUNDARY: 100,
};

export const scoreRules = {
  red: {
    text: 'Need Attention',
    rule: (daysCount: number, pipelineCount: number) =>
      daysCount > DAYS.RED_BOUNDARY ||
      pipelineCount > PIPELINE_COUNT.RED_BOUNDARY,
    info: `Pipeline Count > ${PIPELINE_COUNT.RED_BOUNDARY} and/or MR Days Open > ${DAYS.RED_BOUNDARY}.`,
    icon: StatusError,
  },
  orange: {
    text: 'Advisory',
    rule: (daysCount: number, pipelineCount: number) =>
      daysCount > DAYS.ORANGE_BOUNDARY ||
      pipelineCount > PIPELINE_COUNT.ORANGE_BOUNDARY,
    info: `Pipeline Count > ${PIPELINE_COUNT.ORANGE_BOUNDARY} and/or MR Days Open > ${DAYS.ORANGE_BOUNDARY}.`,
    icon: StatusWarning,
  },
  green: {
    text: 'Healthy',
    rule: (daysCount: number, pipelineCount: number) =>
      daysCount <= DAYS.ORANGE_BOUNDARY &&
      pipelineCount <= PIPELINE_COUNT.ORANGE_BOUNDARY,
    info: `Pipeline Count <= ${PIPELINE_COUNT.ORANGE_BOUNDARY} and MR Days Open <= ${DAYS.ORANGE_BOUNDARY}.`,
    icon: StatusOK,
  },
};
